import '../../reset.css';
import '../../general_styles.css';
import './summary_styles.css';

import NavigationMenu from '../../components/Navigation';
import Titleform from '../../components/Title_form';
import BtnTransition from '../../components/Buttons_Transition';

import { useState, useEffect, useContext } from 'react';

import { useNavigate } from 'react-router-dom';

import { FormValueContext } from '../../contexts/formValues';

function Summary() {

    const { inputArcade, inputAdvanced, inputPro, isYearly, onlineservice, largerStorage, customProfile, textPlan, setTextPlan, totalPrice, setTotalPrice, textPricePlan, setTextPricePlan } = useContext(FormValueContext);

    const navigate = useNavigate();

    let total = totalPrice;

    useEffect(() => {
        console.log(`ARCADE:${inputArcade}`);
        console.log(`ADVANCED:${inputAdvanced}`);
        console.log(`PRO:${inputPro}`);


        setTotalPrice(total + textPricePlan);
        console.log(totalPrice);
        console.log(textPricePlan);

    }, []);

    const submitSummary = (e) => {
        e.preventDefault();
        if (inputArcade || inputAdvanced || inputPro) {
            navigate('/confirmation');
        } else {
            alert('Select a plan to continue');
            return;
        }
    };

    const goToPlan = () => {
        navigate('/plan');
    };

    return (
        <div className='page__container'>
            <div className='form__container'>
                <NavigationMenu />
                <form className='form' onSubmit={(e) => submitSummary(e)}>
                    <Titleform title='Finishing up' text='Double-check everything looks OK before confirming.' />
                    <div className='form__summary'>
                        <div className='summary__chosenplan'>
                            <div>
                                <p className='chosenplan__type'> {textPlan} ({`${isYearly ? 'Yearly' : 'Monthly'}`})</p>
                                <p className='btn__change' onClick={goToPlan}>Change</p>
                            </div>
                            <p className='chosenplan__price'>${textPricePlan}/{isYearly ? 'yr' : 'mo'}</p>
                        </div>
                        <hr></hr>
                        <div className='summary__plus' style={{ 'display': `${onlineservice ? 'flex' : 'none'}` }}>
                            <p className='summaryplus__title'>Online service</p>
                            <p className='summaryplus__price'>{`${isYearly ? '+$10/yr' : '+$1/mo'}`}</p>
                        </div>
                        <div className='summary__plus' style={{ 'display': `${largerStorage ? 'flex' : 'none'}` }}>
                            <p className='summaryplus__title'>Larger Storage</p>
                            <p className='summaryplus__price'>{`${isYearly ? '+$20/yr' : '+$2/mo'}`}</p>
                        </div>
                        <div className='summary__plus' style={{ 'display': `${customProfile ? 'flex' : 'none'}` }}>
                            <p className='summaryplus__title'>Customizable Profile</p>
                            <p className='summaryplus__price'>{`${isYearly ? '+$20/yr' : '+$2/mo'}`}</p>
                        </div>
                        <div className='summary__total'>
                            <p className='summarytotal__title'>Total (per {isYearly ? 'year' : 'month'})</p>
                            <p className='summarytotal__price'>+${totalPrice}/{isYearly ? 'yr' : 'mo'}</p>
                        </div>
                    </div>
                    <BtnTransition hasBackBtn={true} goToBack='/addons' hasNextBtn={true} />
                </form>
            </div>
        </div>
    );
}

export default Summary;